import { useJsApiLoader } from '@react-google-maps/api';
import { useMemo } from 'react';

const libraries = ['places'];

/**
 * Hook to load the Google Maps JavaScript API
 * Only loads the API once and returns the loading state
 */
export const useGoogleMaps = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: window.GOOGLE_MAPS_API_KEY || '',
    libraries,
  });

  return useMemo(
    () => ({
      isLoaded,
      loadError,
    }),
    [isLoaded, loadError]
  );
};
